// extracted by mini-css-extract-plugin
export default {"bold":"SJe4GHeaeUeoFMG62gGK","section":"s80UBCFJpRCPo0Rtqmsw","bordered":"R8PZN_VPEjRkalNUXJs3","aql":"rjLPdhv2tZmjiR3BAM3N"};